import {FilterDialogSectionId, FilterDialogItemId} from 'filters/features/FilterDialog/types';

export const getItemId = (section: FilterDialogSectionId, item: FilterDialogItemId) => {
  return `${section}/${item}`;
};
